<template>
  <div class="view-downloads">
    <div
      class="backdrop"
      @click.self="$emit('close')">
      <div class="modal">
        <ul>
            <li
              :class="{mobile: mobile}"
              v-for="record in submittedwork"
              :key="record.id">
            <p>{{ record.title }}</p>
            <br>
            <a
                :href="record.URL"
                target="_blank">get
                <ArrowNarrowDownIcon
                class="icon"
                />
            </a>
            <br>
            <TrashIcon
                class="icon"
                @click="deleteFile(record.id, record.title)"
                v-if="currentUser.state.role==='teacher'"
            />
            </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import { reactive, toRefs } from '@vue/reactivity'
import { inject, onMounted } from '@vue/runtime-core'
import { TrashIcon, ArrowNarrowDownIcon } from '@heroicons/vue/outline'
import { db, deleteDoc, doc, ref, deleteObject, storage } from '@/firebase/config'

export default {
  components: { TrashIcon, ArrowNarrowDownIcon },
  props: ['submittedwork'],
  setup (props, context) {
    const currentUser = inject('currentUser')
    const responsive = reactive({
      mobile: false,
      windowWidth: null
    })
    let { mobile, windowWidth } = toRefs(responsive)

    // deleteRecord
    const deleteFile = async (id, fileName) => {
      const storedRef = ref(storage, `/schools/inspire-schools/learner/${currentUser.state.grade}/${fileName}`)
      await deleteDoc(doc(db, '/schools/inspire-schools/' + currentUser.state.grade +
      '/uploads/learner', id))
      await deleteObject(storedRef)
      context.emit('close')
      console.log(id, fileName)
    }

    const handleview = () => {
      windowWidth = window.innerWidth
      if (windowWidth <= 750) {
        mobile = true
        return
      }
      mobile = false
    }

    onMounted(() => {
      handleview()
      window.addEventListener('resize', handleview)
    })

    return { mobile, deleteFile, currentUser }
  }
}
</script>

<style>
    .view-downloads .backdrop {
        top: 0;
        left: 0;
        position: fixed;
        background: rgba(0, 0, 0, 0.5);
        width: 100%;
        height: 100%;
        display: grid;
        place-items: center;
        /* z-index: 99; */
    }
    .view-downloads .modal {
        border-radius: 10px;
        max-width: 600px;
        width: 300px;
        background: #fff;
        padding: .5em;
    }
</style>
